export const TAXONOMY_MODEL = "taxonomy";

const taxonomyModel = {
  description: "",
  taxonomy: "",
  term: {}
};

export default taxonomyModel;
